
import { Component, Vue } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { Route } from 'vue-router';
import DateRange from '@/components/DateRange.vue';
import api from '@/api';
import Util from '@/utils/util';
import moment from 'moment';
import itemMixin from '@/minix/itemMixin';

const { report } = api;
@Component({ components: { DateRange } })
export default class SwapOutDiscountCouponReport extends mixins(
  Vue.extend(itemMixin),
) {
  private data = {
    data: [],
    totalPoints: 0,
    totalCount: 0,
    pageSize: 20,
    pageNo: 0,
  };

  private panel = 0;

  private loading = false;

  merchantList: Merchant[] = [];

  private headers = [
    { text: '換出時間', value: 'createdOn', width: 160 },
    { text: '使用時間', value: 'redeemedOn', width: 160 },
    { text: '外部ID', value: 'userIdPublic', width: 100 },
    { text: '姓名', value: 'fullName', width: 100 },
    { text: '兌換品項', value: 'productName', width: 100 },
    { text: '折價方式', value: 'discountRule', width: 100 },
    { text: '兌換商品點數量', value: 'pointValue', width: 100 },
    { text: '消費金額', value: 'price', width: 100 },
    {
      text: '分潤金額',
      value: 'discountVoucherProfitDistributionAmount',
      width: 100,
    },
    { text: '供應商', value: 'merchantName', width: 100 },
    { text: '分店', value: 'storeName', width: 100 },
    { text: '支付方式', value: 'payMethod', width: 100 },
    { text: '支付訂單編號', value: 'paymentTransactionId', width: 100 },
    { text: '折價券獲得方式', value: 'voucherSource', width: 100 },
    { text: '訂單狀態', value: 'voucherStatus', width: 100 },
  ];

  private get totalCount() {
    return this.data.totalCount;
  }

  private get pageCount() {
    return Math.ceil((this.data.totalCount || 0) / (this.data.pageSize || 20));
  }

  private get totalPoints() {
    return this.data.totalPoints;
  }

  private get collection() {
    return [...(this.data.data || [])];
  }

  private get merchantSelectOptions() {
    const mcId = this.filter.merchantCategoryId;
    return this.merchantList
      .filter((m: any) => !mcId || mcId === m.categoryId)
      .map((m: any) => ({
        text: m.merchantName,
        value: m.merchantId,
      }));
  }

  private voucherStatusSelectOptions = [
    { text: '未啟用', value: 0 },
    { text: '啟用', value: 1 },
    { text: '已兌換', value: 2 },
    { text: '已作廢', value: 3 },
    { text: '過期', value: 4 },
    { text: '鎖定', value: 5 },
  ];

  private filter = {
    userIdPublic: this.$route.query.userIdPublic || undefined,
    fullName: this.$route.query.fullName || undefined,
    productName: this.$route.query.productName || undefined,
    merchantCategoryId: Util.isNullOrUndefined(
      this.$route.query.merchantCategoryId,
    )
      ? undefined
      : this.$route.query.merchantCategoryId,
    merchantId: Util.isNullOrUndefined(this.$route.query.merchantId)
      ? undefined
      : +this.$route.query.merchantId,
    voucherStatus: Util.isNullOrUndefined(this.$route.query.voucherStatus)
      ? undefined
      : +this.$route.query.voucherStatus,
    voucherStartDate:
      this.$route.query.voucherStartDate === undefined
        ? this.getToday()
        : this.$route.query.voucherStartDate,
    voucherEndDate: this.$route.query.voucherEndDate || undefined,
    redeemStartDate: this.$route.query.redeemStartDate || undefined,
    redeemEndDate: this.$route.query.redeemEndDate || undefined,
  };

  private pager = {
    pageSize: Util.isNullOrUndefined(this.$route.query.pageSize)
      ? 20
      : +this.$route.query.pageSize,
    pageNo: Util.isNullOrUndefined(this.$route.query.pageNo)
      ? 1
      : +this.$route.query.pageNo,
  };

  private getToday() {
    return moment().format('yyyy-MM-DD');
  }

  private async updatePage(page: number) {
    await this.query(page);
  }

  private async query(page: number) {
    this.pager.pageNo = typeof page === 'number' ? page : 1;
    const query = {
      ...this.filter,
      merchantCategoryId: this.filter.merchantCategoryId
        ? this.filter.merchantCategoryId
        : undefined,
      merchantId: this.filter.merchantId
        ? `${this.filter.merchantId}`
        : undefined,
      voucherStatus: this.filter.voucherStatus
        ? `${this.filter.voucherStatus}`
        : undefined,
      pageSize: `${this.pager.pageSize}`,
      pageNo: `${this.pager.pageNo}`,
    };
    if (this.isQueryChanged(query)) {
      await this.$router.replace({ query });
    }
    await this.requestData();
  }

  private async reset() {
    this.filter = {
      merchantCategoryId: undefined,
      merchantId: undefined,
      userIdPublic: undefined,
      fullName: undefined,
      productName: undefined,
      voucherStatus: undefined,
      voucherStartDate: this.getToday(),
      voucherEndDate: undefined,
      redeemStartDate: undefined,
      redeemEndDate: undefined,
    };
    await this.query(1);
  }

  private isQueryChanged(query: {
    [key: string]: string | Array<string | null> | null | undefined;
  }): boolean {
    return !Object.keys(query).every(
      (key: string) => query[key]?.toString() === this.$route.query[key],
    );
  }

  private async exportCsv() {
    this.loading = true;
    const filter = { ...this.filter };
    const { status, data } = await report.exportSwapOutDiscountCoupon(filter);
    this.loading = false;
    if (status === 0) return;
    Util.saveFile(data, '折價券使用列表.txt');
  }

  private async requestData() {
    this.loading = true;
    const filter = { ...this.filter, ...this.pager };
    const { status, data } = await report.swapOutDiscountCoupon(filter);
    if (status === 1) {
      this.data = data;
    }
    this.loading = false;
  }

  private async beforeRouteEnter(
    to: Route,
    from: Route,
    next: (to?: ((vm: SwapOutDiscountCouponReport) => void) | boolean) => void,
  ) {
    await next(async (vm) => {
      await vm.requestData();
    });
  }
}
